<ng-container *ngIf="boundsStatus$ | async as boundStatus">
  <ng-container>
    <fin-flight-selection-warning
      data-testid="bound-general-errors"
      *ngIf="boundStatus === AirOffersStatus.ERROR"
      [title]="'bookingSearch.errors.noResults.noFlightsFound' | finLocalization"
      [warningNotificationMessage]="'bookingSearch.errors.fetchFailed' | finLocalization"
      [warningNotificationCtaText]="'bookingSearch.errors.actions.reloadPage' | finLocalization"
      (ctaClick)="refetchOffers.emit()"
    >
    </fin-flight-selection-warning>
    <ng-container *ngIf="boundStatus === AirOffersStatus.NO_FLIGHTS_FOUND">
      <ng-container *ngIf="tripType$ | async as tripType">
        <fin-flight-selection-warning
          *ngIf="tripType === TripType.MULTICITY"
          [title]="'bookingSearch.errors.noResults.noFlightsAvailable' | finLocalization"
          [warningNotificationCtaText]="'bookingSearch.pickNewDates' | finLocalization"
          (ctaClick)="backToDateSelection()"
        >
          <div
            class="content"
            data-testid="multi-city-noflights"
            *ngIf="multicityErrorNotification$ | async as message"
          >
            <div class="title font-body-1 content-link" [innerHTML]="message.teaserText | finSafe: 'html'"></div>
          </div>
        </fin-flight-selection-warning>
        <fin-flight-selection-warning
          *ngIf="tripType !== TripType.MULTICITY"
          [showWarningNotification]="false"
          [title]="'bookingSearch.errors.noResults.noFlightsAvailable' | finLocalization"
        >
        </fin-flight-selection-warning>
      </ng-container>
    </ng-container>
    <fin-flight-selection-warning
      *ngIf="boundStatus === AirOffersStatus.INVALID_INPUT"
      [title]="'bookingSearch.errors.noResults.noFlightsFound' | finLocalization"
      [warningNotificationMessage]="'bookingSearch.errors.invalidInput' | finLocalization"
      [warningNotificationCtaText]="'bookingSearch.errors.actions.toFrontPage' | finLocalization"
      (ctaClick)="backToDateSelection()"
    >
    </fin-flight-selection-warning>
  </ng-container>

  <div
    data-testid="air-bounds-embedded-loader"
    class="fill grow--min grey-25-bg flex flex--column flex--center"
    *ngIf="shouldReload && boundStatus === AirOffersStatus.PENDING"
  >
    <fin-loader class="font-body-1" [type]="LoaderType.EMBEDDED" [title]="'ticketSelection.loading'"></fin-loader>
  </div>

  <div class="grey-25-bg" *ngIf="shouldReload === false || boundStatus === AirOffersStatus.OK">
    <fin-ticket-selection-header
      [isOneWay$]="isOneWayBounds$"
      [departureDate$]="departureDate$"
      [returnDate$]="returnDate$"
      [outbound$]="selectedOutbound$ | finMap: 'details'"
      [inbound$]="selectedInbound$ | finMap: 'details'"
      [paxAmount$]="paxAmount$"
      [currencyCode$]="currencyCode$"
      [selectionPhase$]="selectionPhase$"
      [promoCode$]="promoCode$"
      [enableNewLanguageSelector]="enableNewLanguageSelector"
      [enableNewStepper]="enableNewStepper$ | async"
      (clickOutbound)="activateSelectionPhase(SelectionPhase.OUTBOUND)"
      (clickInbound)="activateSelectionPhase(SelectionPhase.INBOUND)"
      [tripLocations]="tripLocations$ | async"
    ></fin-ticket-selection-header>
    <div class="mobile-bleed" *ngIf="selectionPhase$ | async as phase">
      <fin-optimize-air-bounds-bound-selection-list
        *ngIf="phase === SelectionPhase.OUTBOUND"
        [currencyCode$]="currencyCode$"
        [boundType]="BoundType.outbound"
        [bounds$]="outbounds$"
        [boundIdSortOrder$]="outboundIdSortOrder$"
        [selectedBound$]="selectedOutbound$"
        [selectedSortBy$]="selectedSortCriteria$"
        [isLoading]="isLoading"
        [boundsStatus$]="boundsStatus$"
        [selectionPhase]="SelectionPhase.OUTBOUND"
        [showFlightSelectionFilters]="showOutboundFilters$ | async"
        [viewDetailsBtnKey]="
          upgradeAvailabilityEnabled ? 'itineraryAndUpgradesModal.viewDetails' : 'manageMyBooking.widget.viewFullOrder'
        "
        (showDetails)="showDetailsModal($event.details, null, phase, $event.fareFamilies)"
        (selectFareFamily)="selectOutboundFareFamily($event)"
        (openBound)="handleBoundOpen($event, BoundType.outbound)"
        (selectSortBy)="selectSortBy($event)"
        (showSpinner)="onShowSpinner()"
      >
      </fin-optimize-air-bounds-bound-selection-list>

      <fin-optimize-air-bounds-bound-selection-list
        *ngIf="phase === SelectionPhase.INBOUND"
        [currencyCode$]="currencyCode$"
        [boundType]="BoundType.inbound"
        [bounds$]="inbounds$"
        [boundIdSortOrder$]="inboundIdSortOrder$"
        [selectedBound$]="selectedInbound$"
        [selectedSortBy$]="selectedSortCriteria$"
        [boundsStatus$]="boundsStatus$"
        [selectionPhase]="SelectionPhase.INBOUND"
        [isLoading]="isLoading"
        [showFlightSelectionFilters]="showInboundFilters$ | async"
        [viewDetailsBtnKey]="
          upgradeAvailabilityEnabled ? 'itineraryAndUpgradesModal.viewDetails' : 'manageMyBooking.widget.viewFullOrder'
        "
        (showDetails)="showDetailsModal(null, $event.details, phase, $event.fareFamilies)"
        (selectFareFamily)="selectInboundFareFamily($event)"
        (openBound)="handleBoundOpen($event, BoundType.inbound)"
        (selectSortBy)="selectSortBy($event)"
        (showSpinner)="onShowSpinner()"
      >
      </fin-optimize-air-bounds-bound-selection-list>
    </div>
  </div>
</ng-container>

<fcom-cta-button
  data-testid="ticket-selection-cta-button"
  [visible]="(continueEnabled$ | async) && (showContinueButton$ | async)"
  [title]="
    ((selectionPhase$ | async) === SelectionPhase.OUTBOUND && (tripType$ | async) === TripType.RETURN
      ? 'ticketSelection.selectReturnFlight'
      : 'actions.next'
    ) | finLocalization
  "
  [position]="ButtonPosition.GRID_FULL"
  [disabled]="(continueEnabled$ | async) === false"
  (buttonClicked)="onContinueClick($event)"
  class="z3 relative"
>
  <span class="gray-50-text" data-testid="ticket-selection-cta-price-label"
    >{{ 'price.totalPriceAllPassengers' | finLocalization }}:
  </span>
  <span class="font-body-1 bold-type nowrap" data-testid="ticket-selection-cta-price">{{
    selectedBoundsPrice$ | async | finPrice | finEmpty: '&ndash;'
  }}</span>
</fcom-cta-button>

<fcom-modal
  data-testid="details-and-upgrades-modal"
  [title]="(upgradeAvailabilityEnabled ? 'itineraryAndUpgradesModal.title' : 'itinerary.title') | finLocalization"
  [buttons]="ModalButtons.CLOSE"
  [open]="itineraryAndUpgradesModal.open"
  (close)="closeModals()"
>
  <fin-itinerary
    *ngIf="!upgradeAvailabilityEnabled; else tabsContainer"
    class="block pr-medium"
    [outbound$]="itineraryAndUpgradesModal.data.outbound | finToObservable"
    [inbound$]="itineraryAndUpgradesModal.data.inbound | finToObservable"
    [locations$]="locations$"
    [selectionPhase$]="selectionPhase$"
    [isBookingFlow]="true"
  ></fin-itinerary>
  <ng-template #tabsContainer>
    <fcom-tabs
      data-testid="ticket-selection-show-details"
      #tabs
      [layoutType]="TabLayoutType.IN_MODAL"
      (clickedTab)="activeTab$.next($event.index)"
      [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
      [nextButtonAriaLabel]="'carousel.next' | finLocalization"
    >
      <fcom-tab data-testid="flight-details-tab" [title]="'itinerary.title' | finLocalization">
        <fin-itinerary
          class="block pr-medium-x pr-medium-b"
          [outbound$]="itineraryAndUpgradesModal.data.outbound | finToObservable"
          [inbound$]="itineraryAndUpgradesModal.data.inbound | finToObservable"
          [locations$]="locations$"
          [selectionPhase$]="selectionPhase$"
          [isBookingFlow]="true"
        >
        </fin-itinerary>
      </fcom-tab>
      <fcom-tab
        data-testid="upgrade-availability-tab"
        [title]="'itineraryAndUpgradesModal.upgradeAvailability.title' | finLocalization"
      >
        <fin-itinerary-upgrade-availability
          *ngIf="upgradeTabSelected$ | async"
          [bound]="
            (selectionPhase$ | async) === SelectionPhase.OUTBOUND
              ? itineraryAndUpgradesModal.data.outbound
              : itineraryAndUpgradesModal.data.inbound
          "
          [classesForSegments]="itineraryAndUpgradesModal.data.availableClasses"
          [locations]="locations$ | async"
          [selectionPhase$]="selectionPhase$"
          (loginClicked)="triggerLogin()"
          data-testid="booking-itinerary-upgrade-availability"
        ></fin-itinerary-upgrade-availability>
      </fcom-tab>
    </fcom-tabs>
  </ng-template>
</fcom-modal>

<fcom-modal
  class="dimensions-and-details-modal"
  [title]="'fareFamilyDetails.title' | finLocalization"
  [buttons]="ModalButtons.DONE"
  [open]="dimensionsAndDetailsModal.open"
  (close)="closeDimensionAndDetailsModal()"
  data-testid="dimensions-and-details-modal"
>
  <fin-fare-family-details-v2
    *ngIf="dimensionsAndDetailsModal.data"
    class="block"
    [dimensionsAndDetails$]="dimensionsAndDetailsModal.data | finToObservable"
    [showKoreaNotification]="showKoreaNotification$ | async"
    [tripType$]="tripType$"
  >
  </fin-fare-family-details-v2>
</fcom-modal>

<fin-super-light-warning-modal
  [modalOpen]="continueModalV2.open"
  [contentUrl$]="continueModalV2.data?.contentUrlTranslationKey | finToObservable"
  (confirm)="continueSuperLightWarningModal()"
  (closeModal)="closeSuperLightWarningModal()"
></fin-super-light-warning-modal>

<fcom-modal
  class="continue-modal"
  [title]="'modal.genericTitle' | finLocalization"
  [buttons]="ModalButtons.CONTINUE_CANCEL"
  [open]="continueModal.open"
  (confirm)="continueToNextStep()"
  (close)="closeModals()"
  data-testid="ticket-selection-continue-modal"
>
  <div class="pr-large" [class.highlighted-content]="showKoreaNotification$ | async" *ngIf="continueModal.data">
    <cms-unstyled-fragment
      *ngIf="continueModal.data.zeroBaggage"
      [contentUrl$]="'fragments.noBaggageWarning.url' | finLocalization | finToObservable"
      [showIcon]="true"
      class="fragment-inside-modal pr-medium-b block"
    ></cms-unstyled-fragment>
  </div>
</fcom-modal>

<fcom-modal
  *ngIf="promoCodeModal$ | async as promoCodeModal"
  class="promo-code-error-modal"
  [title]="'promoCode.modalTitle' | finLocalization"
  [open]="promoCodeModal.open"
  [buttons]="ModalButtons.CUSTOM"
  (close)="closeModals()"
  data-testid="promo-code-modal"
>
  <div class="pr-large">
    <div class="error-900-text font-body-1">
      {{ 'promoCode.modalWarning' | finLocalization: { code: promoCodeModal.promoCode } }}
    </div>

    <div class="mr-medium-t mr-small-l">
      <div class="nordic-blue-900-text mr-xsmall-b font-body-1">{{ 'promoCode.termsTitle' | finLocalization }}</div>
      <div class="nordic-blue-900-text font-body-1">{{ promoCodeModal.title }}</div>
      <div class="mr-small-l" [innerHTML]="promoCodeModal.terms | resolveLinks | finSafe: 'html'"></div>
    </div>
  </div>
  <div buttons>
    <fcom-button
      [text]="'promoCode.changeYourSearch' | finLocalization"
      (clickBtn)="modifySearchSelection()"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [aria]="{ label: 'promoCode.changeYourSearch' | finLocalization, role: 'button' }"
      class="mr-xsmall-r"
      data-testid="change-search-button"
    ></fcom-button>
    <fcom-button
      [text]="'promoCode.continueWithoutDiscount' | finLocalization"
      (clickBtn)="closeDiscountModal()"
      [aria]="{ label: 'promoCode.continueWithoutDiscount' | finLocalization, role: 'button' }"
      data-testid="continue-without-discount-button"
    ></fcom-button>
  </div>
</fcom-modal>
